export const SuccessMessage = ({ children }: { children: JSX.Element }) => {
  return (
    <div className={'success-message__container'}>
      <div className="row">
        <div className="col-12">{children}</div>
      </div>
    </div>
  );
};
